import React from 'react';

import { observer } from 'mobx-react';

import { Button } from '@infoods/lifebase-ui';

import { scanIqRegistrationService } from '../../../../auth-management';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';
import { openNewTab } from '../../../../shared/utils/windowUtils';
import { useFlag } from '../../../../shared/clients/unleash/useFlag/useFlag';
import { FLAGS } from '../../../../shared/clients/unleash';

const AddNewScanIqCustomerButton = observer(() => {
  const isShowAddScanIqCustomerButton = useFlag(FLAGS.SHOW_ADD_SCAN_IQ_CUSTOMER_BUTTON);
  const { isCoach, isEntity, getEntityId } = loggedInUserDataStore;

  const isAvailable = isShowAddScanIqCustomerButton && (isCoach || isEntity);

  if (!isAvailable) {
    return null;
  }

  const handleAddCustomer = async () => {
    const entityId = getEntityId();
    const { url } = await scanIqRegistrationService.getRegistrationLink(entityId);

    openNewTab(url);
  };

  return (
    <Button variant="contained" onClick={handleAddCustomer}>
      Add New Customer
    </Button>
  );
});

export { AddNewScanIqCustomerButton };
